import type { Hit } from 'instantsearch.js';
import { useInfiniteHits } from 'react-instantsearch-core';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { useIsMdDown } from '@/hooks/useMedia';
import type {
  StoreHit,
  StrapHit,
  WatchHit,
} from '@/integrations/algolia/types';
import { HITS_PER_PAGE } from '@/lib/const';
import { MoreResultsButton } from '@/views/SearchView/MoreResultsButton';

import { BoutiqueCard } from '../BoutiqueCard/BoutiqueCard';
import type { SearchViewType } from '../Search/types';

import * as S from './StoresList.styles';

interface StoresListProps {
  activeTab?: SearchViewType;
  data: Hit<StoreHit>[] | false;
  hitType?: SearchViewType;
  initialResults?: any;
  isOverlay?: boolean;
  nbHits?: number;
  preview?: boolean;
}
export const StoresList = ({
  data,
  hitType,
  initialResults,
  isOverlay = false,
  nbHits,
  preview = false,
}: StoresListProps) => {
  const { hits } = useInfiniteHits<StoreHit>();
  const finalHits = data ? data : hits;

  const isMobileView = useIsMdDown();
  return (
    <S.Wrapper data-test-id='StoresListWrapper'>
      <Flex flexWrap='wrap' justifyContent='center'>
        <S.HitsWrapper col={4}>
          {finalHits
            .slice(0, preview ? HITS_PER_PAGE : undefined)
            .map((hit, index) => {
              return (
                <Box
                  key={hit.objectID}
                  data-test-id={`StoresListProductCard-${index}`}
                >
                  <BoutiqueCard
                    Boutique={hit}
                    isMobileView={isMobileView}
                    type='Search'
                  ></BoutiqueCard>
                </Box>
              );
            })}
        </S.HitsWrapper>
        <MoreResultsButton
          data-test-id='StoresListMoreResultsButton'
          finalHits={data as Hit<WatchHit | StrapHit | StoreHit>[]}
          hitType={hitType}
          initialResults={initialResults}
          isOverlay={isOverlay}
          nbHits={nbHits ?? 0}
        />
      </Flex>
    </S.Wrapper>
  );
};

StoresList.displayName = 'StoresList';
